@if (modell().status === 'hentet') {
  <inline-melding type="info">
    {{ 'Data fra Skatteetaten, oppdatert {dato}.'|translate:{dato: modell().skatteetatenDato()|plaindate} }}
  </inline-melding>

  <div class="topp">
    <div class="legg-til-aksjonær">
      <button mat-button color="primary" (click)="leggTilNyRad(aksjeeiertypePerson)"
              [disabled]="modell().redigererRad()">
        <mat-icon fontSet="ion-ios-plus-outline" class="mat-icon--ionic-ikon"/>
        {{ "Legg til aksjonær" | translate }}
      </button>
    </div>
    <div class="fellesInnføringsdato">
      <mat-form-field>
        <mat-hint>{{ "Dato for anskaffelse"|translate }}</mat-hint>
        <mat-label>{{ "Felles innføringsdato" | translate }}</mat-label>
        <input matInput [matDatepicker]="fellesInnfoeringsdatoVelger"
               [formControl]="modell().skjema.controls.fellesInnfoeringsdato">
        <mat-datepicker-toggle matSuffix [for]="fellesInnfoeringsdatoVelger"/>
        <mat-datepicker #fellesInnfoeringsdatoVelger/>
      </mat-form-field>
    </div>
  </div>
}

<table>
  <thead>
  <tr>
    <th class="navn">{{ "Navn" | translate }}</th>
    <th class="antall">{{ "Antall aksjer" | translate }}</th>
    <th class="klasse">{{ "Klasse" | translate }}</th>
    <th class="andel">{{ "Eierandel" | translate }}</th>
    <th class="orgnummer">{{ "Orgnr/" | translate }}<br>{{ "fødselsdato" | translate }}</th>
    <th class="adresse">{{ "Adresse" | translate }}</th>
    <th class="epost">{{ "E-post" | translate }}</th>
    <th class="innføringsdato">{{ "Innføringsdato" | translate }}</th>
    <th class="meny"><!--meny--></th>
  </tr>
  </thead>
  @if (modell().status === 'laster') {
    <tbody>
    <tr>
      <td colspan="9">
        <laster-data></laster-data>
      </td>
    </tr>
    </tbody>
  }
  @if (modell().status === 'hentet') {
    <tbody>
      @for (m of modell().modeller(); track m.skjema.controls.id.value) {
        @if (!m.redigerer()) {
          <tr [ngClass]="{'slettet':m.slettet()}">
            <td class="navn strike-able">
              {{ m.skjema.controls.navn.value }}
            </td>
            <td class="antall strike-able">
              {{ m.skjema.controls.antallAksjer.value }}
            </td>
            <td class="klasse strike-able">
              {{ m.skjema.controls.aksjeklasse.value }}
            </td>
            <td class="andel strike-able">
              @if (!m.slettet()) {
                {{ m.andel()|percent }}
              }
            </td>
            <td class="orgnummer strike-able">
              @if (m.erPerson()) {
                {{ m.skjema.controls.foedselsdato.value| plaindate:'medium' }}
              } @else {
                {{ m.skjema.controls.organisasjonsnummer.value }}
              }
            </td>
            <td class="adresse strike-able">
              <div>
                <pre>{{ m.skjema.controls.adresse.value }}</pre>
              </div>
            </td>
            <td class="strike-able">
              {{ m.skjema.controls.epost.value }}
            </td>
            <td class="innføringsdato strike-able">
              {{ m.skjema.controls.innfoeringsdato.value| plaindate:'medium' }}
              @if (m.innfoeringsdatoUgyldig()) {
                <span class="advarsel">
                  <i class="icon ion-android-warning"></i>
                </span>
              }
            </td>
            <td>
              @if (!m.slettet()) {
                <button type="button" mat-icon-button [disabled]="modell()?.redigererRad()" [matMenuTriggerFor]="meny"
                        (click)="$event.stopPropagation()" class="mat-medium-icon-button" data-testid="aksjonær-meny-knapp">
                  <mat-icon class="material-symbols-fet">more_vert</mat-icon>
                </button>
                <mat-menu #meny="matMenu">
                  <button mat-menu-item (click)="m.klikkRediger()">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'Rediger' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="modell()?.klikkSlett(m)">
                    <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
                    <span>{{ 'Slett' | translate }}</span>
                  </button>
                </mat-menu>
              }
              @if (m.slettet()) {
                <span [ngClass]="{'angreSlett':true,'deaktivert':modell().redigererRad(), 'klikkbar':!modell().redigererRad()}"
                      (click)="modell()?.klikkAngreSlett(m)">
                  {{ 'ANGRE SLETTING' | translate }}
                </span>
              }
            </td>
          </tr>
        }
        @if (m.redigerer()) {
          <tr class="redigerRad">
            <td colspan="9">
              <ramme-med-tittel [tittel]="m.erNyOgIkkeLagret() ? ('Ny aksjonær'|translate) : ('Rediger aksjonær'|translate) ">
                <ramme-innhold>
                  @if (m.visPersonOrganisasjonsValg()) {
                    <div class="personEllerOrganisasjon">
                      <mat-radio-group [formControl]="m.skjema.controls.type" class="type">
                        <mat-radio-button [value]="aksjeeiertypePerson">{{ "Privatperson" | translate }}</mat-radio-button>
                        <mat-radio-button [value]="aksjeeiertypeOrganisasjon">{{ "Organisasjon" | translate }}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  }
                  <div class="rad1">
                    <div class="navn">
                      <mat-form-field>
                        <mat-label>{{ "Aksjonær" | translate }}</mat-label>
                        <input matInput [formControl]="m.skjema.controls.navn" aria-label="Aksjonær navn">
                      </mat-form-field>
                    </div>
                    <div class="antall">
                      <mat-form-field>
                        <mat-label>{{ "Antall aksjer" | translate }}</mat-label>
                        <input matInput [formControl]="m.skjema.controls.antallAksjer" aria-label="Antall Aksjer">
                      </mat-form-field>
                    </div>
                    <div class="klasse">

                      <mat-form-field>
                        <mat-label>{{ "Klasse" | translate }}</mat-label>
                        <input matInput [formControl]="m.skjema.controls.aksjeklasse" aria-label="klasse">
                      </mat-form-field>
                    </div>
                    <div class="andel">
                      <mat-form-field>
                        <mat-label>{{ "Eierandel" | translate }}</mat-label>
                        <input matInput disabled="true" value="{{ m.andel()|percent }}">
                      </mat-form-field>

                    </div>
                  </div>
                  <div class="rad2">
                    <div class="orgnr">
                      @if (m.erOrganisasjon()) {
                        <mat-form-field>
                          <mat-label>{{ "Organisasjonsnummer" | translate }}</mat-label>
                          <input matInput [formControl]="m.skjema.controls.organisasjonsnummer">
                        </mat-form-field>
                      }
                      @if (m.erPerson()) {
                        <mat-form-field>
                          @if (erIkkeNil(m.modell?.foedselsAar)) {
                            <mat-hint>{{ "Født {aar}"|translate:{aar: m.modell.foedselsAar} }}</mat-hint>
                          }
                          <mat-label>{{ "Fødselsdato" | translate }}</mat-label>
                          <input matInput [matDatepicker]="foedselsdatoVelger" [formControl]="m.skjema.controls.foedselsdato">
                          <mat-datepicker-toggle matSuffix [for]="foedselsdatoVelger"/>
                          <mat-datepicker [startAt]="m.startFoedselsdato()" #foedselsdatoVelger/>
                        </mat-form-field>
                      }
                    </div>
                    <div class="adresse">
                      <mat-form-field>
                        <mat-label>{{ "Adresse" | translate }}</mat-label>
                        <textarea matInput [formControl]="m.skjema.controls.adresse" cdkTextareaAutosize
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="5"></textarea>
                      </mat-form-field>
                    </div>
                    <div class="epost">
                      <mat-form-field>
                        <mat-label>{{ "E-post" | translate }}</mat-label>
                        <input matInput [formControl]="m.skjema.controls.epost" aria-label="e-post">
                      </mat-form-field>
                    </div>
                    <div class="innfoeringsdato">
                      <mat-form-field>
                        <mat-hint>{{ "Dato for anskaffelse"|translate }}</mat-hint>
                        <mat-label>{{ "Innføringsdato" | translate }}</mat-label>
                        <input matInput [matDatepicker]="innfoeringsdatoVelger" [formControl]="m.skjema.controls.innfoeringsdato">
                        <mat-datepicker-toggle matSuffix [for]="innfoeringsdatoVelger"/>
                        <mat-datepicker #innfoeringsdatoVelger/>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="redigerKnapper">
                    @if (m.erFraSkatteetaten()) {
                      <button mat-raised-button (click)="m.resett()">
                        {{ "Tilbakestill"|translate }}
                      </button>
                    } @else {
                      <button mat-raised-button (click)="modell().klikkSlett(m)">
                        {{ "Slett"|translate }}
                      </button>
                    }
                    <button mat-raised-button [disabled]="!m.kanSkjemaLukkes()" (click)="m.klikkRedigeringFerdig()" color="primary">
                      @if (m.erNyOgIkkeLagret()) {
                        {{ "Legg til aksjonær"|translate }}
                      } @else {
                        {{ "Lukk"|translate }}
                      }
                    </button>
                  </div>
                </ramme-innhold>
              </ramme-med-tittel>
            </td>
          </tr>
        }
      }
    </tbody>
  }
  <tfoot>
  <tr>
    <td class="navn">{{ "Totalt" | translate }}</td>
    <td class="antall">{{ modell().totaltAntallAksjer() }}</td>
    <td class="klasse">
      @if (modell().totaltAntallAksjerPerAksjeklasse().size > 1) {
        <antall-aksjer-per-aksjeklasse [aksjeklasserMedAntall]="modell().totaltAntallAksjerPerAksjeklasse()"/>
      }
    </td>
    <td class="andel">
    </td>
    <td class="orgnummer">
      <!--      {{modell.aksjenummerIBruk()|aksjenummerintervaller}}-->
    </td>
    <td class="adresse"><!--adresse--></td>
    <td class="epost"><!--epost--></td>
    <td class="innføringsdato"><!--innføringsdato--></td>
    <td class="meny"><!--kommentar--></td>
  </tr>
  </tfoot>
</table>
@if (modell().status === 'hentet') {

  @if (!modell().alleInnfoeringsDatoLagtInn()) {
    <inline-melding type="feil" voksHorisontalt="true">
      <div>{{ "Du må legge til innføringsdato på aksjonærene" | translate }}</div>
    </inline-melding>
  }

  @if (modell().skjema.dirty) {
    <inline-melding type="advarsel" voksHorisontalt="true">
      <div>{{ "Hvis du avbryter så mister du alle endringer" | translate }}</div>
    </inline-melding>
  }
}

@if (modell().status === 'ikkeFunnet') {
  <inline-melding type="advarsel">
    <div>{{ "Fant ikke noen aksjonærer hos skatteetaten" | translate }}</div>
    <div>{{ "Data skal være oppdatert per {dato}" | translate:{dato: modell().skatteetatenDato()|plaindate} }}</div>
  </inline-melding>
}

@if (modell().status === 'feilet') {
  <inline-melding type="feil">
    <div>{{ "Henting av aksjonærer fra skatteetaten feilet" | translate }}</div>
  </inline-melding>
}
